var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.089,16.423H7.448a4.483,4.483,0,0,1-4.455-4.412A4.488,4.488,0,0,1,7.448,7.577h3.641v1.5H7.448a2.923,2.923,0,1,0,0,5.846h3.641Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.552,16.423H12.911v-1.5h3.641a2.923,2.923,0,1,0,0-5.846H12.911v-1.5h3.641a4.484,4.484,0,0,1,4.455,4.412A4.487,4.487,0,0,1,16.552,16.423Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.345,
    y: 11.25,
    width: 7.301,
    height: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSmall);
export default __webpack_public_path__ + "static/media/link_small.591b6e805cf3ba565a4623357c37452d.svg";
export { ForwardRef as ReactComponent };